import React from 'react';

const Tier3Description = () => {
  return (
    <>
      Best for clients with over <b>150k MAU</b> or enterprise product and support needs
    </>
  );
};

export default Tier3Description;
